import { Station } from '@app/core/types/stations';
import {
  filterAdoverlayData,
  formatAdoverlayData,
  formatAdoverlayForMarker,
} from '@app/modules/logger/screens/stream/components/audit/adoverlay/utils';
import {
  PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum,
  PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum,
  PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum,
  pntAppControllerGetSegmentAdOverlayByDateQueryKey,
  usePntAppControllerGetSegmentAdOverlayByDate,
} from '@mi-front/api-v2';
import { DateTimeStr, TimeRange } from '@mi-front/core';
import { isAdOverlayEnabled } from '../../../helpers';

const adOverlayQueryParams = (range: TimeRange<DateTimeStr>) => ({
  from: range.from,
  to: range.to,
  withResults: PntAppControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum.true,
  sortBy: PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum.date,
  sortOrder: PntAppControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum.desc,
});

/**
 * Fetches ad overlay detections for a station time range and formats them as stream markers.
 */
export function useAdOverlayMatches(station: Station, range: TimeRange<DateTimeStr>) {
  const params = adOverlayQueryParams(range);

  return usePntAppControllerGetSegmentAdOverlayByDate(station.slug, params, {
    query: {
      enabled: isAdOverlayEnabled(station),
      select: (results) =>
        formatAdoverlayForMarker(formatAdoverlayData(filterAdoverlayData(results))),
    },
  });
}

useAdOverlayMatches.queryKey = (station: Station, range: TimeRange<DateTimeStr>) =>
  pntAppControllerGetSegmentAdOverlayByDateQueryKey(station.slug, adOverlayQueryParams(range));
